import React, { ErrorInfo } from 'react';
import styles from './ErrorBoundary.module.scss';
import { ErrorPage } from '../ErrorPage/ErrorPage';
import ErrorBoundaryService, { ErrorType } from '../../services/ErrorBoundaryService';
import { t } from 'i18next';

class ErrorBoundary extends React.Component {
  state = {
    hasError: false,
    error: { message: '', stack: '' },
    info: { componentStack: '' },
    errorType: ErrorType.ReactError,
  };

  static getDerivedStateFromError = () => {
    return { hasError: true };
  };

  componentDidCatch = (error: Error, info: ErrorInfo) => {
    sessionStorage.clear();
    console.error('Uncaught error', error, info);
    this.setState({ error, info });
  };

  componentDidMount() {
    sessionStorage.removeItem('state');
    if (this.state.hasError) {
      console.error(this.state.error);
      console.log(this.state.info.componentStack);
    }
    ErrorBoundaryService.getErrorBoundaryState(this.setState.bind(this));
  }

  render() {
    const { hasError } = this.state;
    //eslint-disable-next-line
    const { children } = this.props;

    // Style Error Component - To Do
    return hasError ? (
      <>
        <div className={styles['header-div']}>
          <div className={styles['parker-logo']}>
            <a href="https://www.parker.com/">
              <img
                src="https://www.parker.com/parker/newparkerstyle/responsive/images/logo.png"
                alt="Parker Logo"
              />
            </a>
          </div>
        </div>
        <ErrorPage errorType={this.state.errorType} />
        <div className={styles['footer-div']}>
          <h6 className={styles['copyright-text']}>{t('Copyright')}</h6>
          <div className="image-div">
            <img
              src="https://www.parker.com/parker/jsp/career2015/images/Engg.png"
              alt="Engineering your success"
              title="Engineering your success"
            />
          </div>
        </div>
      </>
    ) : (
      children
    );
  }
}

export default ErrorBoundary;
